// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReembolsoRouteImport } from './routes/reembolso'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as PlanilhaVsAppRouteImport } from './routes/planilha-vs-app'
import { Route as EsqueciSenhaRouteImport } from './routes/esqueci-senha'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CalculadorasIndexRouteImport } from './routes/calculadoras.index'
import { Route as AprendaIndexRouteImport } from './routes/aprenda.index'
import { Route as CalculadorasJurosCompostosRouteImport } from './routes/calculadoras.juros-compostos'
import { Route as CalculadorasGasolinaEtanolRouteImport } from './routes/calculadoras.gasolina-etanol'
import { Route as AprendaSlugRouteImport } from './routes/aprenda.$slug'
import { Route as AppTransacoesRouteImport } from './routes/_app.transacoes'
import { Route as AppRecorrentesRouteImport } from './routes/_app.recorrentes'
import { Route as AppMetasRouteImport } from './routes/_app.metas'
import { Route as AppInvestimentosRouteImport } from './routes/_app.investimentos'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppAssinaturaRouteImport } from './routes/_app.assinatura'
import { Route as AppAdicionarRouteImport } from './routes/_app.adicionar'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermosRoute = TermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ReembolsoRoute = ReembolsoRouteImport.update({
            id: '/reembolso',path: '/reembolso',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const PlanilhaVsAppRoute = PlanilhaVsAppRouteImport.update({
            id: '/planilha-vs-app',path: '/planilha-vs-app',getParentRoute: () => rootRouteImport
          })
const EsqueciSenhaRoute = EsqueciSenhaRouteImport.update({
            id: '/esqueci-senha',path: '/esqueci-senha',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CalculadorasIndexRoute = CalculadorasIndexRouteImport.update({
            id: '/calculadoras/',path: '/calculadoras/',getParentRoute: () => rootRouteImport
          })
const AprendaIndexRoute = AprendaIndexRouteImport.update({
            id: '/aprenda/',path: '/aprenda/',getParentRoute: () => rootRouteImport
          })
const CalculadorasJurosCompostosRoute = CalculadorasJurosCompostosRouteImport.update({
            id: '/calculadoras/juros-compostos',path: '/calculadoras/juros-compostos',getParentRoute: () => rootRouteImport
          })
const CalculadorasGasolinaEtanolRoute = CalculadorasGasolinaEtanolRouteImport.update({
            id: '/calculadoras/gasolina-etanol',path: '/calculadoras/gasolina-etanol',getParentRoute: () => rootRouteImport
          })
const AprendaSlugRoute = AprendaSlugRouteImport.update({
            id: '/aprenda/$slug',path: '/aprenda/$slug',getParentRoute: () => rootRouteImport
          })
const AppTransacoesRoute = AppTransacoesRouteImport.update({
            id: '/transacoes',path: '/transacoes',getParentRoute: () => AppRoute
          })
const AppRecorrentesRoute = AppRecorrentesRouteImport.update({
            id: '/recorrentes',path: '/recorrentes',getParentRoute: () => AppRoute
          })
const AppMetasRoute = AppMetasRouteImport.update({
            id: '/metas',path: '/metas',getParentRoute: () => AppRoute
          })
const AppInvestimentosRoute = AppInvestimentosRouteImport.update({
            id: '/investimentos',path: '/investimentos',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppAssinaturaRoute = AppAssinaturaRouteImport.update({
            id: '/assinatura',path: '/assinatura',getParentRoute: () => AppRoute
          })
const AppAdicionarRoute = AppAdicionarRouteImport.update({
            id: '/adicionar',path: '/adicionar',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppAdicionarRoute: AppAdicionarRoute,AppAssinaturaRoute: AppAssinaturaRoute,AppDashboardRoute: AppDashboardRoute,AppInvestimentosRoute: AppInvestimentosRoute,AppMetasRoute: AppMetasRoute,AppRecorrentesRoute: AppRecorrentesRoute,AppTransacoesRoute: AppTransacoesRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AuthRoute: AuthRoute,ContatoRoute: ContatoRoute,EsqueciSenhaRoute: EsqueciSenhaRoute,PlanilhaVsAppRoute: PlanilhaVsAppRoute,PrivacidadeRoute: PrivacidadeRoute,ReembolsoRoute: ReembolsoRoute,ResetPasswordRoute: ResetPasswordRoute,TermosRoute: TermosRoute,UnsubscribeRoute: UnsubscribeRoute,AprendaSlugRoute: AprendaSlugRoute,CalculadorasGasolinaEtanolRoute: CalculadorasGasolinaEtanolRoute,CalculadorasJurosCompostosRoute: CalculadorasJurosCompostosRoute,AprendaIndexRoute: AprendaIndexRoute,CalculadorasIndexRoute: CalculadorasIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)